import { FilterGroup } from 'api-paths-cas';
import { notEmpty } from '@/utilities/helpers';
import { IGetFilterGroupsProps } from '..';
import { getTagsFilter } from './tags/tags';

export const getOtherGroupFilters = (props: IGetFilterGroupsProps): FilterGroup => {
  return {
    name: 'OTHER',
    filters: [getTagsFilter(props)].filter(notEmpty),
  };
};
